export default __webpack_public_path__ + "static/media/gifti-icon.8ba29555.svg";